export const ONBOARDING_AMPLITUDE_EVENTS = {
	GOAL: 'goal',
	WELCOME: 'WEB onboarding welcome shown',
	MENU_CONTACT_SUPPORT_CLICKED: 'Web contact support clicked',
	USER_ANSWER: 'WEB onboarding welcome answer',
	QUIZ: 'WEB onboarding',
	AFTER_EMAIL_LOADER: 'WEB after email loader shown',
	AFTER_SECOND_QUIZ: 'WEB after ikea quiz loader shown',
	EMAIL_COMPLETED: 'WEB onboarding email completed',
	EMAIL_SHOWN: 'WEB onboarding enter email shown',
	EMAIL_ACCOUNT_EXISTS: 'WEB onboarding account exists',
	EMAIL_ERROR: 'WEB onboarding email fail',
	EMAIL_OPTIN_SHOW: 'WEB onboarding email optin popup shown',
	EMAIL_OPTIN_ANSWER: 'WEB onboarding email optin answer',
	PAYMENT_SHOWN: 'payment page shown',
	PAYMENT_CLOSE: 'payment page closed',
	PAYMENT_ERROR: 'payment error',
	PAYMENT_FAILED: 'payment fail',
	PAYMENT_SUCCESS: 'pay pressed',
	PAYMENT_SUCCESS_PAGE: 'payment success page',
	PAYMENT_PAYPAL_SUCCESS: 'paypal pressed',
	POPUP_FINISHER_SHOWN: 'special offer shown',
	POPUP_FINISHER_CONTINUE: 'special offer continue clicked',
	MERCHANT: 'merchant data',
	ONE_CLICK_MERCHANT: 'one click pay merchant data',
	ERROR: 'WEB onboarding error',
	REMOVE_BACKGROUND: 'RB onboarding',
	RB_HOME_FEATURE: 'RB background feature',
	TEMPLATES_CONTENT_TYPE: 'Templates content type',
	WELCOME_BOOST_SHOWN: 'welcome boost shown',
	WELCOME_BOOST_GET_GUIDE_SHOWN: 'welcome boost get guide shown',
	POPUP_PAYMENT_LOADER: 'after payment loader shown',
	WEB_APP_PRESSED: 'web app pressed',
	INSTALL_PRESSED: 'install pressed',
	ENTER_NAME_SHOWN: 'WEB onboarding enter name shown',
	FINAL_SHOWN: 'WEB onboarding final shown',
	ANALYZE_LOADER_SHOWN: 'WEB after email loader shown',
	CHECKBOX_NOT_PRESSED: 'checkbox not pressed',
};
